export default __webpack_public_path__ + "static/media/side6.eac66143.svg";